import React from 'react';
import classNames from 'classnames';
import find from 'lodash.find';
import {svgs} from 'epic-diesel-common/src/constants';
import {Icon} from 'epic-diesel-common';

//@ts-ignore
import styles from './DropList.pcss';

export interface DropListProps {
    name: string;
    value: string | boolean;
    options: {
        value: string;
        label: string;
    }[];
    onChange?: (name: string, value: string | boolean) => void;
    className?: string;
    listClass?: string;
    activeClass?: string;
    icon?: React.ReactNode;
    optionLabel?: string;
    optionValue?: string;
    labelLength?: number;
    disabled?: boolean;
    searchable?: boolean;
    lightTheme?: boolean;
    autoComplete?: string;
}

interface DropListState {
    active: boolean;
    optionLabel: DropListProps['optionLabel'];
    optionValue: DropListProps['optionValue'];
    label: string;
}

class DropList extends React.Component<DropListProps, DropListState> {
    constructor(props) {
        super(props);
        this.state = {
            active: false,
            optionLabel: props.optionLabel || 'label',
            optionValue: props.optionValue || 'value',
            label: ''
        };
    }

    toggleActive = () => {
        if (this.props.disabled || (this.props.options && this.props.options.length < 2)) return;
        const active = !this.state.active;
        this.setState({active});
    };

    onClick = event => {
        event.stopPropagation();

        const {name, onChange} = this.props;
        const {value} = event.target.dataset;
        this.setState({active: false, label: ''});
        if (onChange) onChange(name, value);
    };

    onChange = event => {
        this.setState({active: true, label: event.target.value});
    };

    hidePopover = () => {
        setTimeout(() => {
            this.setState({active: false, label: ''});
        }, 200);
    };

    render() {
        const {active, optionValue, optionLabel} = this.state;
        const {
            value,
            options,
            className,
            listClass,
            activeClass,
            labelLength,
            disabled,
            lightTheme,
            autoComplete,
            searchable = true,
            icon = <Icon className={styles.dropListIcon} icon={svgs.CHEVRON_DOWN} />
        } = this.props;

        const search = {
            [optionValue]: value
        };

        const current = find(options, search) || {};
        const hasMoreThanOneOption = options && options.length > 1;

        let label = current[optionLabel];
        if (labelLength) {
            label = label && label.substring(0, labelLength);
        }

        let newOptions = options;
        if (this.state.label) {
            newOptions = options.filter(
                item =>
                    item[optionLabel] &&
                    item[optionLabel].toLowerCase().indexOf(this.state.label.toLowerCase()) !== -1
            );
        }

        const classes = classNames(styles.dropList, className, {
            [styles.active]: active,
            [activeClass]: active,
            [styles.disabled]: disabled
        });

        const listClasses = classNames(styles.list, listClass, {
            [styles.light]: lightTheme
        });

        /**
         * TODO: The <input /> should be hidden (rendered with display none).
         * All other presentation elements (div, span, etc) should change
         * state in the hidden input mentioned above.
         */
        return (
            <div
                className={classes}
                tabIndex={-1}
                onBlur={this.hidePopover}
                onClick={this.toggleActive}>
                <input
                    name="label"
                    onChange={this.onChange}
                    disabled={disabled || !searchable}
                    placeholder={this.state.label || label}
                    value={active ? this.state.label : label}
                    className={styles.input}
                    autoComplete={autoComplete}
                />
                {hasMoreThanOneOption && (
                    <div>
                        {icon}
                        <div className={listClasses}>
                            {(!disabled || this.state.label) &&
                                newOptions.map((item, index) => (
                                    <div
                                        key={index}
                                        data-value={item[optionValue]}
                                        onClick={this.onClick}>
                                        {item[optionLabel]}
                                    </div>
                                ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default DropList;
